const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

/** Host + API version prefix, e.g. `http://135.13.28.178:8080/v1` */
const apiBaseUrl = trimTrailingSlash(process.env.REACT_APP_API_BASE_URL ?? "");

if (
  process.env.NODE_ENV === "production" &&
  apiBaseUrl.startsWith("http://") &&
  !/^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(apiBaseUrl)
) {
  // eslint-disable-next-line no-console
  console.warn(
    "[security] REACT_APP_API_BASE_URL uses http in production. Prefer https to protect data in transit.",
  );
}

const clientAppBaseUrl = trimTrailingSlash(
  process.env.REACT_APP_CLIENT_APP_BASE_URL ?? "https://app.netshieldtech.com",
);

export const env = {
  appName: process.env.REACT_APP_NAME ?? "NS Admin Onboarding",
  apiBaseUrl,
  /**
   * Client portal origin for this environment (welcome / login links).
   * Must match onboarding-api `CLIENT_APP_BASE_URL` for the same env.
   */
  clientAppBaseUrl,
  /** Hostname derived from {@link clientAppBaseUrl} (no scheme). */
  clientAppHost: clientAppBaseUrl.replace(/^https?:\/\//i, ""),
  /**
   * Fallback phone only — welcome email prefers the assigned account manager's
   * phone when available. Name is never defaulted to a specific person.
   */
  supportContactPhone:
    process.env.REACT_APP_SUPPORT_CONTACT_PHONE ?? "+91 80 XXXX XXXX",
} as const;
